<template>
  <div class="time-input">
    <div class=time-input__label>{{label}}</div>
    <div class="time-input__input">
      <the-mask
          type="text"
          class="time-input__input-time"
          @input="updateInput"
          :mask="'##:##'"
          :tokens="{'#': {pattern: /[0-9]/}}"
          v-model="maskValue"
          v-bind="$attrs"
          placeholder="--:--" />
    </div>
  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask'
export default {
  components: {
    TheMask,
  },
  name: "TimeInput",
  data(){
    return {
      maskValue: this.value
    }
  },
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    label: {
      type: String,
    }
  },
  methods: {
    updateInput() {
      this.maskValue = +this.maskValue.slice(0, 2) > 23 ? 23 : this.maskValue;
      this.maskValue.length === 4
          ? (this.maskValue = +this.maskValue.slice(2, 5) > 59 ? this.maskValue.slice(0, 2) + '59' : this.maskValue)
          : false;
      this.$emit('input', this.maskValue)
    }
  }
}
</script>

<style scoped lang="scss">
.time-input {
  position: relative;
  display: flex;
  align-items: center;
  width: 190px;
  max-width: 200px;
  margin-left: 0.625rem;
  justify-content: space-between;

  @media (max-width: 767px) {
    margin-left: 0;
    width: 100%;
    max-width: 100%;
  }

  &__label {
    font-size: 1.2rem;
    line-height: 1.5rem;
    margin-right: 1rem;
    white-space: nowrap;
    color: #979797;
  }

  &__input {
    position: relative;

    &-time {
      text-align: left;
      position: relative;
      z-index: 3;
      background-color: transparent;
      max-width: 7.8rem;
      padding: 0 8px !important;
      height: 3.6rem;
      font-size: 1.2rem;
      line-height: 1em;
      color: #2e2e2e;
      outline: none;
      box-shadow: none;
      border-radius: 3px;
      border: 1px solid #bcbcbc;
      transition-property: border-color, background-color;
      transition-duration: 0.3s;
      transition-timing-function: ease;
      width: 100%;

      &:disabled {
        border: 1px solid #bcbcbc50;
        color: #2e2e2e50;
      }

      &:focus {
        outline: none;
        box-shadow: none;
        border-color: #929292;
      }
    }
  }
}
</style>